/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Front_Deft_Liger_SlurpInputs */

const fr_front_deft_liger_slurp = /** @type {(inputs: Front_Deft_Liger_SlurpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titre`)
};

/**

* @param {Front_Deft_Liger_SlurpInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const front_deft_liger_slurp = /** @type {((inputs?: Front_Deft_Liger_SlurpInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Front_Deft_Liger_SlurpInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_front_deft_liger_slurp(inputs)
});